module.exports = __webpack_public_path__ + "static/img/7.a835277.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/7.png
// module id = ZCl0
// module chunks = 1